module.exports = __webpack_public_path__ + "img/android5bg6.b610f6ab.png";